import React, { useState, useEffect, useCallback } from "react";
import { Container, Row, Col } from "react-bootstrap";
import IDSTable from "./IDSTable";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import Form from "react-bootstrap/Form";
import Alert from "react-bootstrap/Alert";
import Accordion from "react-bootstrap/Accordion";
import FormGroup from "@mui/material/FormGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import InputAdornment from "@mui/material/InputAdornment";
import TextField from "@mui/material/TextField";
import { fetchMasterTransactionDataWithFilter } from "../services/errorMessageQueue-service";
import { getAllFacilities } from "../services/sendingFacilities-service";
import { eicrMasterQueueHeadCells } from "../util/headcells-util";
import { S3_URL } from "../services/Constants";
import { urlWithFilterParams, validateAndSanitizeUrl } from "../util/common";
import { Autocomplete } from "@mui/material";
import Cookies from "js-cookie";
import { useLocation } from "react-router-dom";

const EicrMasterQueue = () => {
  const location = useLocation();
  const STATUS_VALUES = ["PROCESSED", "ERROR", "IN_PROGRESS", "DUPLICATE", "EXCEPTION"];
  const [recordsPerPage, setRecordsPerPage] = useState(Cookies.get("itemsPerPage")?Cookies.get("itemsPerPage"):5);
  const [pageNo, setPageNo] = useState(location?.state?.pageNo ? location?.state?.pageNo : 0 );
  const [isFetchError, setIsFetchError] = useState(false);
  const [facilityData, setFacilityData] = useState([]);
  const [filter, setFilter] = useState(
    location?.state?.filter ? location?.state?.filter : {msh12:["eicr"]}
  );
  const [transactionData, setTransactionData] = useState(null);
  const [showFilterModal, setShowFilterModal] = useState(false);

  const [checkedValues, setCheckedValues] = useState(location?.state?.filter?.sendingFacilityName ? location?.state?.filter?.sendingFacilityName :[]);
  const [checkedStatusValues, setCheckedStatusValues]= useState(location?.state?.filter?.status ? location?.state?.filter?.status :[]);
  const [isError, setIsError] = useState(false);
  const [alertMessage, setAlertMessage] = useState();
  const [selectedSendingFacility, setSelectedSendingFacility]  = useState([]);
  
  const handleFilterModalClose = () => setShowFilterModal(false);

  const setRecordsPerPageCallback = (value) => {
    setRecordsPerPage(value);
  };

  const setPageNoCallback = (value) => {
    setPageNo(value);
  };

  const getTransactionData = useCallback(
    async (filter) => {
      let response = await fetchMasterTransactionDataWithFilter(
        pageNo,
        recordsPerPage,
        urlWithFilterParams(filter)
      );
      if (response.ok) {
        let data = await response.json();
        if (data?.genericList != null) {
          const genericList = data.genericList.map((item) => ({
            ...item, 
            clia:  item?.sendingFacility?.clia,
            SendingFacilityidORcliaORoidORNPI:
            item?.msh12 === "eICR"
              ? item?.npi
              : item?.sendingFacility?.sendingFacilityIdentifier ||
                item?.sendingFacility?.clia ||
                item?.sendingFacility?.oid ||
                item?.sendingFacility?.npi,
         }));
         const data2={...data, genericList : genericList}
          setIsFetchError(false);
          setIsError(false);
          setTransactionData(data2);
        } else {
          setIsFetchError(true);
          setIsError(true);
        }
      } else {
        let error = await response.json();
        if (error.description === "No Transaction record found!") {
          setIsFetchError(false);
          setIsError(false);
          setTransactionData({
            genericList: [],
            totalPages: 0,
            totalRecords: 0,
          });
        } else {
          setIsFetchError(true);
          setIsError(true);
          setAlertMessage(error?.description);
        }
      }
    },
    [pageNo, recordsPerPage]
  );

  useEffect(() => {
    getTransactionData(filter);
    getFacilities();
  }, [pageNo, recordsPerPage, getTransactionData]);
   
  useEffect(() => {
    if (facilityData && location?.state?.filter?.sendingFacilityName) {
      const filteredData = facilityData.filter(item =>
        location.state.filter.sendingFacilityName.includes(item.sendingFacilityName)
      );
    setSelectedSendingFacility(filteredData);
    } else {
      setSelectedSendingFacility([]);
    }
  }, [facilityData, location?.state?.filter?.sendingFacilityName]);

  const setFilterField = (field, value) => {
    setFilter({
      ...filter,
      [field]: value,
    });
  };

  const getFacilities = async () => {
    let response = await getAllFacilities();
    if (response.ok) {
      let data = await response.json();
      setFacilityData(data);

      if (data && location?.state?.filter?.sendingFacilityName) {
        const filteredData = data.filter(item =>
          location.state.filter.sendingFacilityName.includes(item.sendingFacilityName)
        );
        setSelectedSendingFacility(filteredData);
      } else {
        setSelectedSendingFacility([]);
      }
    } else {
      let error = await response.json();
      setIsError(true);
      setAlertMessage(error?.description);
    }
  };

  const handleResetFilter = () => {
    setCheckedValues([]);
    setCheckedStatusValues([]);
    setFilter({msh12:["eicr"]});
  };
  const handleShowFilter = () => {
    setIsError(false);

    setShowFilterModal(true);
  };
  const handleFilter = (event) => {
    event.preventDefault();
    setPageNo(0);
    pageNo === 0 && getTransactionData(filter);
    handleFilterModalClose();
  };

  const handleCheckboxChange = (event) => {
    let copyCheckedValues = [...checkedValues];

    if (copyCheckedValues.includes(event.target.name)) {
      copyCheckedValues = copyCheckedValues.filter(
        (item) => item !== event.target.name
      );
    } else {
      copyCheckedValues = [...copyCheckedValues, event.target.name];
    }
        setCheckedValues(copyCheckedValues);
    setFilterField("sendingFacilityName", copyCheckedValues);
  };

  const handleStatusCheckboxChange = (event) => {
    let copyCheckedValues = [...checkedStatusValues];

    if (copyCheckedValues.includes(event.target.name)) {
      copyCheckedValues = copyCheckedValues.filter(
        (item) => item !== event.target.name
      );
    } else {
      copyCheckedValues = [...copyCheckedValues, event.target.name];
    }
    setCheckedStatusValues(copyCheckedValues);
    setFilterField("status", copyCheckedValues);
  };

  const emptyButtonsLayout = () => {
    return <div />;
  };

  const renderBannerMessage = () => {
    if (isError) {
      return alertMessage
        ? alertMessage
        : "Something went wrong, please try again";
    }
  };

  const setExpandedAccordion = () => {
    let active = [];
    if (filter?.startDate || filter?.endDate) {
      active.push("0");
    }
    if (checkedValues.length > 0) {
      active.push("1");
    }
    if (checkedStatusValues.length > 0) {
      active.push("2");
    }
    return active;
  };
  
  return (
    <Container fluid className="errorMessageContainer">
      <Row style={{ paddingLeft: "13px" }}>
        <Col xl={8}>
          <Row className="tableTitle generalFont">eICR Master Message Queue</Row>
          <Row className="tableSubtitle generalFont">
            You have{" "}
            {transactionData?.totalRecords > 0
              ? transactionData.totalRecords
              : 0}{" "}
            Messages Awaiting action
          </Row>
        </Col>
      </Row>
      {isError && (
        <Alert
          style={{ marginRight: "125px" }}
          key={"success"}
          variant={isError ? "danger" : "success"}
          onClose={() => {
            setIsError(false);
          }}
          dismissible
        >
          {renderBannerMessage()}
        </Alert>
      )}
      <IDSTable
        isFetchError={isFetchError}
        setPageNoCallback={setPageNoCallback}
        setRecordsPerPageCallback={setRecordsPerPageCallback}
        headCells={eicrMasterQueueHeadCells}
        rows={transactionData?.genericList}
        pages={transactionData?.totalPages}
        buttonsLayout={emptyButtonsLayout}
        isEicrMasterQueue={true}
        handleShowFilter={handleShowFilter}
        filter={filter}
        pageNo={pageNo}
      />
      <Modal
        show={showFilterModal}
        onHide={handleFilterModalClose}
        size="sm"
        centered
        dialogClassName="my-modal-30"
      >
        <Modal.Header className="modalHeaderContainer" closeButton>
          <Modal.Title className="modalHeader generalFont">
            Apply Filters
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="modalBodyContainer">
          <React.Fragment>
            <Form.Label className="modalLabel generalFont">
              <TextField
                className="my-modal-searchbox-30"
                size="small"
                placeholder="Identifier"
                value={filter.id ? filter.id : ""}
                onChange={(e) =>
                  setFilterField(
                    "id",
                    e.target.value.length > 0 ? e.target.value : null
                  )
                }
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="start">
                      <img
                        src={`${validateAndSanitizeUrl(S3_URL)}search-icon.png`}
                        alt=""
                        style={{ height: "19px", width: "19px" }}
                      ></img>
                    </InputAdornment>
                  ),
                }}
              />
            </Form.Label>
            <br />
            <br />
            <Form.Label className="modalLabel generalFont">
              <TextField
                className="my-modal-searchbox-30"
                size="small"
                placeholder="Message Control ID"
                value={filter.messageControlId ? filter.messageControlId : ""}
                onChange={(e) =>
                  setFilterField(
                    "messageControlId",
                    e.target.value.length > 0 ? e.target.value : null
                  )
                }
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="start">
                      <img
                        src={`${validateAndSanitizeUrl(S3_URL)}search-icon.png`}
                        alt=""
                        style={{ height: "19px", width: "19px" }}
                      ></img>
                    </InputAdornment>
                  ),
                }}
              />
            </Form.Label>
            <br />
            <br />
            <Form.Label className="modalLabel generalFont">
              <TextField
                className="my-modal-searchbox-30"
                size="small"
                placeholder="Sending Facility Id"
                value={filter.clia ? filter.clia : ""}
                onChange={(e) =>
                  setFilterField(
                    "clia",
                    e.target.value.length > 0 ? e.target.value : null
                  )
                }
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="start">
                      <img
                        src={`${validateAndSanitizeUrl(S3_URL)}search-icon.png`}
                        alt=""
                        style={{ height: "19px", width: "19px" }}
                      ></img>
                    </InputAdornment>
                  ),
                }}
              />
            </Form.Label>
            <br />
            <br />
            <Accordion
              alwaysOpen
              disablegutters="true"
              defaultActiveKey={setExpandedAccordion()}
            >
              <Accordion.Item eventKey="0">
                <Accordion.Header>
                  <div className="bold">Time Transaction Received</div>
                </Accordion.Header>
                <Accordion.Body>
                  <Form.Group className="mb-3" controlId="form.startDate">
                    <React.Fragment>
                      <Form.Label className="modalLabel generalFont">
                        Start Date <i className="text-danger"></i>
                      </Form.Label>
                    </React.Fragment>
                    <Form.Control
                      className="modalInput generalFont"
                      type="date"
                      placeholder="Enter Text"
                      required
                      value={filter.startDate ? filter.startDate : ""}
                      onChange={(e) =>
                        setFilterField("startDate", e.target.value)
                      }
                    />
                  </Form.Group>

                  <Form.Group className="mb-3" controlId="form.endDate">
                    <React.Fragment>
                      <Form.Label className="modalLabel generalFont">
                        End Date <i className="text-danger"></i>
                      </Form.Label>
                    </React.Fragment>
                    <Form.Control
                      className="modalInput generalFont"
                      type="date"
                      placeholder="Enter Text"
                      required
                      value={filter.endDate ? filter.endDate : ""}
                      onChange={(e) =>
                        setFilterField("endDate", e.target.value)
                      }
                    />
                  </Form.Group>
                </Accordion.Body>
              </Accordion.Item>
              <br />
              <Accordion.Item eventKey="1">
                <Accordion.Header>
                  <div className="bold">Sending Facility (Name)</div>
                </Accordion.Header>
                <Accordion.Body
                  style={{
                    maxHeight: "200px",
                    overflow: "scroll",
                    overflowX: "hidden",
                  }}
                >
                  <FormGroup>
                    {facilityData && (
                      <Autocomplete
                        multiple
                        id="tags-standard"
                        options={facilityData.sort(
                          (a, b) =>
                            -b.sendingFacilityName.localeCompare(
                              a.sendingFacilityName
                            )
                        )}
                        getOptionLabel={(option) => {
                          return (
                            option?.sendingFacilityName?.trim() 
                          );
                        }}
                        defaultValue={selectedSendingFacility}
                        onChange={(event, newValue) => {
                          setSelectedSendingFacility(newValue);
                          setFilterField(
                            "sendingFacilityName",
                            newValue.map((v) => v?.sendingFacilityName)
                          );
                        }}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            variant="standard"
                            placeholder="Search Sending Facility"
                          />
                        )}
                      />
                    )}
                  </FormGroup>
                </Accordion.Body>
              </Accordion.Item>
              <br />
              <Accordion.Item eventKey="2">
                <Accordion.Header>
                  <div className="bold">Status</div>
                </Accordion.Header>
                <Accordion.Body>
                  <FormGroup>
                    {STATUS_VALUES.map((item) => {
                      return (
                        <FormControlLabel
                          control={
                            <Checkbox
                              checked={checkedStatusValues.includes(item)}
                              onChange={handleStatusCheckboxChange}
                              name={item}
                            />
                          }
                          label={item}
                        />
                      );
                    })}
                  </FormGroup>
                </Accordion.Body>
              </Accordion.Item>
            </Accordion>
          </React.Fragment>
        </Modal.Body>
        <Modal.Footer
          className="modalFooterContainer"
          style={{ justifyContent: "space-between", marginLeft: "23px" }}
        >
          <Button
            onClick={handleResetFilter}
            className="modalAddUpdateStyle generalFont flexCenter modalRemoveStyle"
          >
            Reset
          </Button>
          <Button
            onClick={handleFilter}
            className="modalAddUpdateStyle generalFont flexCenter"
          >
            Filter
          </Button>
        </Modal.Footer>
      </Modal>
    </Container>
  );
};

export default EicrMasterQueue;
